module.exports = __webpack_public_path__ + "font/4376652caec8a8cd4024347f48b1330f.otf";